import { render, staticRenderFns } from "./OrderDetailsItemView.vue?vue&type=template&id=baf582f6&"
import script from "./OrderDetailsItemView.vue?vue&type=script&lang=js&"
export * from "./OrderDetailsItemView.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailsItemView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports